<template>
  <v-snackbar v-model="visible" :color="color" top class="sbclass">
    {{ message }}
    <v-btn dark text @click="visible = false">
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      color: "",
      message: ""
    };
  },
  methods: {
    show(msg, type) {
      this.message = msg;
      if (type == "error") this.color = "#cc0000";
      else if (type == "success") this.color = "success";
      else if (type == "info") this.color = "info";
      else if (type == "warning") this.color = "warning";
      else return;
      this.visible = true;
    }
  }
};
</script>

<style scoped>
</style>